<template><!-- 登録モーダル -->
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
        <CRow>
        <CCol>
          <table class="table">
            <thead>
              <a style="font-size: 20px"><strong>登録内容確認</strong></a>
              <CCardText><strong>以下の内容を登録してよろしいですか？</strong></CCardText>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a><strong>氏名</strong></a><br>
                  {{ user }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>電話番号</strong></a><br>
                  {{ tel }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>住所</strong></a><br>
                  {{ live }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>E-Mail</strong></a><br>
                  {{ mail }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>パスワード</strong></a><br>
                  {{ pass }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>所属部署</strong></a><br>
                  {{ department_name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>入社年月日</strong></a><br>
                  {{ formatDate(hire_date) }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>ユーザ種別</strong></a><br>
                  {{ select }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>承認者権限</strong></a><br>
                  <block v-if="approver_flg === true">有</block>
                  <block v-else>無</block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>週稼働日数（有休付与区分）</strong></a><br>
                  {{
                    working_days === 5
                      ? '通常(週5日)'
                      : (working_days === 0 ? '有休付与無し' : ('週' + working_days + '日'))
                  }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>有給日数</strong></a><br>
                  {{ paid }}<block v-if="paid">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>代休日数</strong></a><br>
                  {{ comp }}<block v-if="comp">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>今期有休消化日数</strong></a><br>
                  {{ paid_used }}<block v-if="paid_used">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>有給付与月</strong></a><br>
                  {{ paid_add }}<block v-if="paid_add">月</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>固定内残業</strong></a><br>
                  {{ fixed_over_time }}<block v-if="fixed_over_time"></block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>Slack ID</strong></a><br>
                  {{ slack_id }}<block v-if="slack_id"></block><block v-else></block>
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
        </CRow>
        <CRow>
          <CCol>
            <button @click="$emit('close')" class="btn btn-secondary btn-sm">キャンセル</button>
          </CCol>
          <CCol>
            <save-button
              :label="'登録'"
              :loading="loading"
              :disabled="authorized"
              @click="$emit('register')"
              class="btn btn-info"
            />
          </CCol>
        </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton';
export default {
  name: 'RegisterModal',
  components: { SaveButton },
  data () {
    return {
    }
  },
  props: {
    user: String,
    tel: String,
    live: String,
    mail: String,
    pass: String,
    hire_date: String,
    department_name: String,
    select: String,
    approver_flg: Boolean,
    working_days: Number,
    paid: String,
    comp: String,
    paid_used: String,
    paid_add: String,
    fixed_over_time: String,
    slack_id: String,
    authorized: Boolean,
    loading: Boolean,
  },
  methods: {
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
}
</script>

<style scoped>
td {
  word-break: break-all;
}
  .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(80, 80, 80, 0.5);
      display: table;
      transition: opacity .3s ease;
    }
    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }
    .modal-container {
      width: 40%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }
</style>
